import { Injectable } from "@angular/core";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";

@Injectable({
  providedIn: 'root',
})

export class CommonUtilService {

  static uniPattern: any = new RegExp('[^\x00-\x7F]+');

  static BANK_TYPE_SEQUENCE = [
    {
      title: 'Scheduled Bank',
      type: 'SCHEDULED_BANK',
      serialNo: 1
    },
    {
      title: 'Non Scheduled Bank',
      type: 'NON_SCHEDULED_BANK',
      serialNo: 2
    },
    {
      title: 'NBFI',
      type: 'NBFI',
      serialNo: 3
    },
    {
      title: 'Central Bank',
      type: 'CENTRAL_BANK',
      serialNo: 4
    },
    {
      title: 'Post Office',
      type: 'POST_OFFICE',
      serialNo: 5
    },
    {
      title: 'Other',
      type: 'OTHERS',
      serialNo: 6
    }
  ];

  static BORROWING_FROM_BANK_TYPE_SEQUENCE = [
    {
      title: 'Scheduled Bank',
      type: 'SCHEDULED_BANK',
      serialNo: 1
    },
    {
      title: 'Non Scheduled Bank',
      type: 'NON_SCHEDULED_BANK',
      serialNo: 2
    },
    {
      title: 'NBFI',
      type: 'NBFI',
      serialNo: 3
    },
    {
      title: 'Central Bank',
      type: 'CENTRAL_BANK',
      serialNo: 4
    },
    {
      title: 'Other',
      type: 'OTHERS',
      serialNo: 6
    }
  ];

  constructor() { }


  public static readonly MAX_SAFE_INTEGER_DIGITS = 16;

  public static numberOnly(event, maxIntegerDigits: number = CommonUtilService.MAX_SAFE_INTEGER_DIGITS): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    if (charCode >= 48 && charCode <= 57 && event.target) {
      const input = event.target as HTMLInputElement;
      const digits = input.value.replace(/,/g, '').replace(/^-/, '').split('.')[0].replace(/\D/g, '');
      if (digits.length >= maxIntegerDigits) {
        return false;
      }
    }

    return true;

  }

  public static removeZero(mobileNo: string): string {

    if (mobileNo[0] === "0")
      mobileNo = mobileNo.substr(1);

    return mobileNo;

  }

  public static addZero(mobileNo: string): string {

    if (mobileNo[0] !== "0")
      mobileNo = "0" + mobileNo;

    return mobileNo;

  }

  public static dateValidator(date: string): boolean {

    return false;

  }

  public static restrictNonAsciiComment(event): boolean {
    return this.uniPattern.test(event.target.value);
  }

  static getAssessmentYearFromDate(date) {
    const month = date.getMonth();

    if (month >= 0 && month <= 5) {
      return `${date.getFullYear() - 1}-${date.getFullYear()}`;
    }

    return `${date.getFullYear()}-${date.getFullYear() + 1}`;
  }

  static getLastFinancialYear() {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    return CommonUtilService.getFinancialYearFromDate(date);
  }

  static getFinancialYearFromDate(date) {
    const month = date.getMonth();

    if (month >= 0 && month <= 5) {
      return `${date.getFullYear() - 1}-${date.getFullYear()}`;
    }

    return `${date.getFullYear()}-${date.getFullYear() + 1}`;
  }

  public static toNormalAssessmentYearFormat(value):string{
    const assessmentYearArray = value.split('_');
    return `${assessmentYearArray[1]}-${assessmentYearArray[2]}`
  }

  public static toApiAssessmentYearFormat(value):string{
    const assessmentYearArray = value.split('-');
    return `AY_${assessmentYearArray[0]}_${assessmentYearArray[1]}`
  }

  public static getPreviousAssessmentYear(current:string):string{
    const currentAssessmentYearArray = current?.split('-');
    return currentAssessmentYearArray?.length == 2 ? `${Number(currentAssessmentYearArray[0])-1}-${Number(currentAssessmentYearArray[1])-1}` : '';
  }

  public static sortBankList(bankList: any[]) {
    let sortedBankList = [];
    
    CommonUtilService.BANK_TYPE_SEQUENCE.forEach(sequenceItem => {
      const matchingBanks = bankList.filter(bank => bank.type === sequenceItem.type);
      sortedBankList = sortedBankList.concat(matchingBanks);
    });
    
    return sortedBankList;
  }

  public static getInvalidFields(formGroup: UntypedFormGroup, parentPath: string = ''): string[] {
    const invalidFields: string[] = [];

    // Include group-level errors on this formGroup itself
    if (formGroup.errors) {
      invalidFields.push(`${parentPath || '<root>'} (group errors: ${Object.keys(formGroup.errors).join('|')})`);
    }

    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      const fieldPath = parentPath ? `${parentPath}.${key}` : key;

      if (control instanceof UntypedFormGroup) {
        // Add group-level errors on the child group
        if (control.errors) {
          invalidFields.push(`${fieldPath} (group errors: ${Object.keys(control.errors).join('|')})`);
        }
        for (const field of this.getInvalidFields(control, fieldPath)) {
          invalidFields.push(field);
        }
      } else if (control instanceof UntypedFormArray) {
        // Add array-level errors
        if (control.errors) {
          invalidFields.push(`${fieldPath} (array errors: ${Object.keys(control.errors).join('|')})`);
        }
        control.controls.forEach((arrayControl, index) => {
          const itemPath = `${fieldPath}[${index}]`;
          if (arrayControl instanceof UntypedFormGroup) {
            if (arrayControl.errors) {
              invalidFields.push(`${itemPath} (group errors: ${Object.keys(arrayControl.errors).join('|')})`);
            }
            for (const field of this.getInvalidFields(arrayControl, itemPath)) {
              invalidFields.push(field);
            }
          } else if (arrayControl instanceof UntypedFormArray) {
            if (arrayControl.errors) {
              invalidFields.push(`${itemPath} (array errors: ${Object.keys(arrayControl.errors).join('|')})`);
            }
            // Recurse further if you can have nested arrays
            arrayControl.controls.forEach((innerCtrl, innerIdx) => {
              if (innerCtrl.invalid) invalidFields.push(`${itemPath}[${innerIdx}]`);
            });
          } else if (arrayControl && arrayControl.invalid) {
            invalidFields.push(itemPath);
          }
        });
      } else if (control && control.invalid) {
        invalidFields.push(fieldPath);
      }
    });

    return invalidFields;
  }

}